import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { PurchaseOrderConfirmationsPage } from "src/components/views/erp/purchase/purchaseOrderConfirmations/PurchaseOrderConfirmationsPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/purchase/purchaseOrderConfirmations")({
	staticData: { title: i18n.t("purchase_order_confirmations"), legacyViewKey: "purchaseOrderConfirmationsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <PurchaseOrderConfirmationsPage />;
}
